import { render, staticRenderFns } from "./stuansquenum.vue?vue&type=template&id=70d0a356&scoped=true"
import script from "./stuansquenum.vue?vue&type=script&lang=js"
export * from "./stuansquenum.vue?vue&type=script&lang=js"
import style0 from "./stuansquenum.vue?vue&type=style&index=0&id=70d0a356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0a356",
  null
  
)

export default component.exports